// @auto-index

import cover from './cover.jpg'
import Description from './Description.txt'
import icon from './icon.jpg'
import screenshots from './screenshots'

export { default as cover } from './cover.jpg'
export { default as Description } from './Description.txt'
export { default as icon } from './icon.jpg'
export { default as screenshots } from './screenshots'

export default {
  cover,
  Description,
  icon,
  screenshots
}
